// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"20260121.33506"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";
import { SENTRY_IGNORE_LIST } from "@talladega/constants";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tunnel: "/api/sentry/tunnel",
  tracesSampleRate: 0.05,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.3,
  integrations: [
    Sentry.replayIntegration({
      blockAllMedia: false,
      beforeErrorSampling: (error) => {
        const errorType = error.exception?.values[0]?.type;
        const errorValue = error.exception?.values[0]?.value;
        const pageUrl = error.request?.url;

        // Capture replays if they are not from the admin page
        // Or if they are not in the SENTRY_IGNORE_LIST
        return !(
          (pageUrl && pageUrl.includes("admin")) ||
          (errorType &&
            errorValue &&
            SENTRY_IGNORE_LIST.includes(`${errorType}: ${errorValue}`)) ||
          (errorValue && SENTRY_IGNORE_LIST.includes(errorValue))
        );
      },
    }),
  ],
  environment: process.env.NEXT_PUBLIC_ENV_NAME,
  enabled: process.env.NEXT_PUBLIC_ENV_NAME !== "local",
  ignoreErrors: SENTRY_IGNORE_LIST,
  maxValueLength: 8192, // The max
  beforeSend: (event) => {
    const userAgent = navigator.userAgent || "";

    const isBot = /googleother/i.test(userAgent);
    const isCrawler = /meta-externalagent|bingbot|crawler/i.test(userAgent);

    const isURLConstructionError = event.exception?.values?.some(
      (err) =>
        err.type === "TypeError" &&
        /Failed to construct 'URL': Invalid URL/.test(err.value || "")
    );

    if ((isBot && isURLConstructionError) || isCrawler) {
      return null;
    }

    return event;
  },
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
